import React from 'react';
import Divider from '@solid-ui-components/Divider';
import FeaturesBlock from '@solid-ui-blocks/Features/Block11';
import LayoutWrapper from '@solid-ui-layout/LayoutWrapper';
import FeatureWithIconList from '@solid-ui-blocks/FeaturesWithPhoto/FeatureWithIconList/Block04';
import FeaturesTabOne from '@solid-ui-blocks/FeaturesWithPhoto/Block07';
import { Box, Flex } from 'theme-ui';
import ContentText from '@solid-ui-components/ContentText';
import styles from './styles';
import Hero from '@solid-ui-blocks/Hero/Block06';

const IndustryBlock04 = ({
  content,
  vertical,
  heading = true,
  variants = ['blue', 'purple', 'yellow', 'green'],
  omitBlock = false,
  omitReview = false,
}) => (
  <>
    <LayoutWrapper divider={<Divider />}>
      {vertical ? (
        <Hero content={content['hero']} />
      ) : (
        <FeaturesTabOne
          customButton
          content={content['features-tab-one']}
          reverse
        />
      )}
      <FeaturesBlock content={content['advantages']} />
      <Box sx={styles.headingBetweenBlocks}>
        {heading && (
          <ContentText content={content['feature-photo-heading']?.text} />
        )}
        <FeatureWithIconList
          content={content['feature-with-icon-list-1']}
          top
          reverse
          variant={variants[0]}
        />
      </Box>
      <FeatureWithIconList
        content={content['feature-with-icon-list-2']}
        top
        variant={variants[1]}
      />
      {!omitBlock && (
        <FeatureWithIconList
          content={content['feature-with-icon-list-3']}
          top
          reverse
          variant={variants[2]}
        />
      )}
      <FeatureWithIconList
        content={content['feature-with-icon-list-4']}
        top
        variant={variants[3]}
      />
    </LayoutWrapper>
  </>
);

export default IndustryBlock04;
